import React from 'react'
import { AllowedAccess } from 'react-permission-role'
import { useLocation, useParams } from 'react-router-dom'
import { Card, CardContent, Button, Grid } from '@mui/material';

import { useFetchInitGeneralManagements } from './hooks'
import { TableGeneralManagements } from './TableGeneralManagements'
import { FormGeneralManagements } from './FormGeneralManagements'

export const GeneralManagements = () => {

    const location = useLocation();
    const paramsURL = useParams();
    const useFetchInit = useFetchInitGeneralManagements({location, paramsURL})

    // console.log('location ::: ', location)
    const lastPartUrl = location.pathname.split('/').pop()
    const isActive = lastPartUrl === 'activas'
    
    const {
        globalStates,
        Actions
    } = useFetchInit
    
    const { showForm, formOpeningMode } = globalStates
    
    const { handleClickShowForm } = Actions
    
    const readOnlyMode = !isActive || formOpeningMode === 'READONLY'
    return (
        <AllowedAccess permissions={['249_GESTIONES_ACTIVAS', '250_GESTIONES_CERRADAS']} renderAuthFailed={<p>Error</p>}>
            <div className="content">
                {(!showForm) && (
                    <>
                        <div className="panel-body">
                            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <Card style={{zIndex:'1'}}>
                                        <CardContent>
                                            
                                            <div className='h4 mt-1 mb-1'> Gestiones generales</div>
                                            <div className="border-bottom border-dark"></div>

                                            {(isActive)&&(
                                                <div className="d-flex justify-content-end pt-4">
                                                <Button
                                                    style={{background: "#4b4b4c"}}
                                                    variant="contained"
                                                    type="button"
                                                    onClick={handleClickShowForm}
                                                >
                                                    <i className="fa-solid fa-plus"></i> &nbsp; Agregar
                                                </Button>
                                            </div>
                                            )}
                                            

                                            <div className="pt-4"></div>
                                            <TableGeneralManagements useFetchInit={useFetchInit} readOnlyMode={readOnlyMode} />
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>
                        </div>
                    </>
                )}
                {(showForm) && (
                    <>
                        <div className="panel-body">
                            <FormGeneralManagements useFetchInit={useFetchInit} readOnlyMode={readOnlyMode} />
                        </div>
                    </>
                )}
            </div>
        </AllowedAccess>
    )
}
